/* import __COLOCATED_TEMPLATE__ from './project-completion-project-information.hbs'; */
import { alias } from '@ember/object/computed';
import EmberObject, { computed } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@ember/component';
import { showModal } from "sh-www/utils/modal-controls";
import { APPLICATION } from "../../models/application";
import { LOCATION } from 'sh-www/models/location';

/**
 * This is the project information section of the project completion flow
 */
export default Component.extend({
  /**
   * @inheritDoc
   */
  tagName: 'div',
  classNames: ['SH-c-project-completion-project-information'],
  classNameBindings: [
    '_isCanSeeProjectInformation::hide'
  ],

  /**
   * Register services
   */
  state: service('states/routes/project-completion'),
  stateManager: service('state-managers/routes/project-completion'),
  session: service(),

  /*********************************
   * REQUIRED PARAMS
   *********************************/

  /*********************************
   * OPTIONAL PARAMS
   **********************************/

  /*********************************
   * LIFECYCLE FUNCTIONS
   **********************************/

  /*********************************
   * PRIVATE
   **********************************/

  /**
   * @type {Boolean}
   */
  _canSeeCostCodes: computed(
  'state.isBuyerViewing',
  'session.currentUser.company.usesCostCodes',
  function() {
    return this.state.isBuyerViewing && this.session.currentUser.company?.usesCostCodes;
  }),

  /**
   * @type {Boolean}
   */
  _isCanSeeProjectInformation: computed(
  'state.isBuyerViewing',
  'state.application.status',
  function() {
    return this.get('state.isBuyerViewing') || this.get('state.application.status') === APPLICATION.STATUS.ACTIVE;
  }),

  /**
   * @type {Boolean} Whether there is currently a location selected.
   */
  _hasLocationSelected: computed(
    'state.application.location.{placeId,locationType}',
    function () {
      return this.get('state.application.location.placeId')
        && this.get('state.application.location.locationType') !== 'country';
    }
  ),

  /**
   * @type {String} The location text to display for the user.
   */
  _locationText: computed(
    'state.application.location.{placeId,locationType,formattedAddress}',
    function() {
      if (!this.get('state.application.location.placeId')) {
        return 'Not selected';
      }

      if (this.get('state.application.location.locationType') === LOCATION.TYPES.COUNTRY) {
        return 'Not selected';
      }

      return this.get('state.application.location.formattedAddress');
    }
  ),

  /**
   * All selected services for the review
   *
   * NOTE --- THIS IS ALIASED TO THE MAIN STATE!!
   *
   * @type {Ember.A<Service>}
   */
  _selectedServices: alias('state.selectedServices'),

  actions: {
    /**
     * User clicks to edit services.
     */
    onEditServicesClicked: function() {
      const modalData = EmberObject.create({
        actorUser: this.session.currentUser,
        application: this.get('state.application'),
        selectedServices: this.get('state.application.services'),
        onServicesUpdated: (selectedServices) => {
          this.get('stateManager.handleServicesUpdated').perform(selectedServices);
        },
      });

      showModal(this, 'projects/edit-services-modal', modalData);
    },

    /**
     * User clicks to location.
     */
    onEditLocationClicked: function() {
      const modalData = EmberObject.create({
        actorUser: this.session.currentUser,
        application: this.get('state.application'),
        selectedLocation: this.get('state.application.location'),
        onLocationUpdated: (selectedLocation) => {
          this.get('stateManager.handleLocationUpdated').perform(selectedLocation);
        },
        onLocationDeleted: () => {
          this.get('stateManager.handleLocationDeleted').perform();
        },
      });

      showModal(this, 'projects/edit-location-modal', modalData);
    },

    /**
     * User clicks to edit codes.
     */
    onEditStoryCodesClicked: function() {
      const modalData = EmberObject.create({
        actorUser: this.session.currentUser,
        application: this.get('state.application'),
        costCodeRequired: this.state.application.buyer.company.doesRequireCostCodes,
        onStoryCodesUpdated: () => {
          this.get('stateManager').storyCodesUpdated();
        }
      });

      showModal(this, 'projects/edit-story-codes-modal', modalData);
    }
  }
});
